export const waitlist_url =
  "https://server.newslettrai.com/landing/v1/waitlist/";
export const email_regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const landing_status = {
  contact: "Contact",
  waitlist: "Waitlist",
};

export const social_media_links = {
  instagram: "https://www.instagram.com/newslettrai?igsh=MTU1aG1lbGh3ZjM0NQ==",
  linkedin: "https://www.linkedin.com/in/varad-patil-754348346/",
  twitter: "https://x.com/newslettrai",
};

export const popuptype_status = {
  error: "error",
  success: "success",
};
